import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllBanks.graphql';
import { Query, QueryallBanksArgs } from '../../__generated__/globalTypes';

export const useAllBanksQuery = (options?: QueryHookOptions<Query, QueryallBanksArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallBanksArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllBanksLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallBanksArgs>
): QueryResult<Query, QueryallBanksArgs> & { getAllBanks: LazyQueryExecFunction<Query, QueryallBanksArgs> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllBanks, result] = useLazyQuery<Query, QueryallBanksArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllBanks, ...result };
};

export const useAllBanksPromiseQuery = () => {
  const client = useApolloClient();

  const getAllBanks = useCallback(
    (options?: Omit<QueryOptions<QueryallBanksArgs, Query>, 'query'>) =>
      client.query<Query, QueryallBanksArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllBanks };
};
// Suspense Query Hooks
export const useAllBanksSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QueryallBanksArgs>) => {
  const result = useSuspenseQuery<Query, QueryallBanksArgs>(QUERY, {
    ...options
  });

  return result;
};
